// routes/ProtectedRoute.js
import React from "react";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ user, allowedRole, children }) {
  if (!user) {
    return <Navigate to="/admin/login" replace />;
  }

  if (user.role !== allowedRole) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
}
